import React, { useState } from 'react';
import { View, TextInput, TouchableOpacity, StyleSheet, Alert, ActivityIndicator } from 'react-native';
import { Text } from '@/components';
import { ArrowLeft } from 'lucide-react-native';
import { useAuth } from '@/context/AuthContext';
import { useCreateGroup } from '@/lib/queries/groups';
import theme from '@/constants/colors';
import { Typography } from '@/constants/typography';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { logEvent } from '@/lib/analytics';

// Packs only — family creation moved to Settings → Account.
export default function CreateGroupScreen() {
  const { t } = useTranslation();
  const { session } = useAuth();
  const token = session?.accessToken;
  const router = useRouter();
  const insets = useSafeAreaInsets();
  const [name, setName] = useState('');
  const createMutation = useCreateGroup(token);

  const handleCreate = async () => {
    if (!name.trim()) return;
    try {
      const g = await createMutation.mutateAsync({ name: name.trim(), type: 'pack' });
      logEvent('group_created', { group_id: g.id });
      router.replace(`/group/${g.id}` as any);
    } catch (e: any) {
      Alert.alert(t('common.error'), e?.message || t('groups.createFailed'));
    }
  };

  return (
    <View style={[styles.container, { paddingTop: insets.top + 12 }]}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => router.back()} hitSlop={12}><ArrowLeft size={26} color={theme.accentPrimary} /></TouchableOpacity>
        <Text style={styles.title}>{t('groups.create')}</Text>
        <View style={{ width: 26 }} />
      </View>

      <View style={styles.body}>
        <Text style={styles.label}>{t('groups.nameLabel')}</Text>
        <TextInput
          style={styles.input}
          value={name}
          onChangeText={setName}
          placeholder={t('groups.namePlaceholder')}
          placeholderTextColor={theme.textMuted}
          autoFocus
        />

        <TouchableOpacity style={styles.createBtn} onPress={handleCreate} disabled={createMutation.isPending || !name.trim()}>
          {createMutation.isPending ? <ActivityIndicator color={theme.backgroundPrimary} /> : <Text style={styles.createBtnText}>{t('groups.create')}</Text>}
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: theme.backgroundPrimary },
  header: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingHorizontal: 16, paddingBottom: 8 },
  title: { ...Typography.body(theme.textPrimary), fontSize: 20, fontWeight: '700' },
  body: { padding: 16 },
  label: { ...Typography.label(theme.textMuted), marginBottom: 8 },
  input: { backgroundColor: theme.backgroundSecondary, borderRadius: 12, padding: 14, color: theme.textPrimary, fontSize: 16, borderWidth: 1, borderColor: theme.borderSubtle },
  createBtn: { backgroundColor: theme.accentPrimary, borderRadius: 16, padding: 16, alignItems: 'center', marginTop: 24 },
  createBtnText: { color: theme.backgroundPrimary, fontWeight: '700', fontSize: 16 },
});